import React, { useId, useState } from "react";
import Reveal from "./Reveal";

// SEZIONE 6 — FAQ accordion accessibile
const FAQS = [
  {
    q: "Forfy sostituisce il commercialista?",
    a: "No, e non vuole farlo. Forfy tiene i tuoi dati ordinati e aggiornati, così dai al tuo commercialista meno lavoro — e tu hai sempre la situazione sotto controllo.",
  },
  {
    q: "I miei dati fiscali sono al sicuro?",
    a: "Sì. Forfy gira su infrastruttura Google Cloud, è conforme al GDPR e non condivide i tuoi dati con nessuno.",
  },
  {
    q: "Cosa succede dopo i 30 giorni di prova?",
    a: "Continui ad avere accesso alle funzioni base, gratis. Nessun addebito automatico, nessuna carta richiesta.",
  },
  {
    q: "Funziona se sono al 5% o al 15%?",
    a: "Sì. Forfy riconosce la tua aliquota e applica automaticamente quella corretta in ogni calcolo.",
  },
  {
    q: "Posso esportare i miei dati quando voglio?",
    a: "Sempre. Fatture, clienti e dati fiscali sono tuoi: li esporti in CSV o PDF in qualsiasi momento.",
  },
];

function FaqItem({ item, isOpen, onToggle }) {
  const baseId = useId();
  const buttonId = `${baseId}-btn`;
  const panelId = `${baseId}-panel`;

  return (
    <div className={`faq-item ${isOpen ? "is-open" : ""}`.trim()}>
      <h3 className="faq-question-wrap">
        <button
          type="button"
          id={buttonId}
          className="faq-question"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={onToggle}
        >
          <span>{item.q}</span>
          <svg
            className="faq-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className="faq-answer"
        hidden={!isOpen}
      >
        <p>{item.a}</p>
      </div>
    </div>
  );
}

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="section-heading section-heading--center">
          <Reveal as="p" className="section-label">
            Domande frequenti
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            Le risposte alle domande più comuni.
          </Reveal>
        </div>

        <Reveal className="faq-list" delay={120}>
          {FAQS.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
}
